<template>
  <Modal
    class="tw-translate-y-[-50%] !tw-max-h-[913px] role-details-modal"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :visible="showRef"
    :value="formModel"
    @close="handleCloseModal"
  >
    <ModalHeader
      :title="getUiText('app-settings-team-roles-add-role-modal-title-1')"
      @close="handleCloseModal"
    />
    <BaseForm
      :show="showRef"
      :enter-event="true"
      class="tw-overflow-auto"
      @on:submit="onSubmit"
    >
      <div class="tw-p-10 modal-manage-role">
        <div class="tw-flex tw-items-center tw-gap-[15px]">
          <span
            class="tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none"
            >{{
              getUiText("app-settings-team-roles-add-role-modal-sub-title-1")
            }}</span
          >
        </div>
        <div class="tw-flex tw-flex-col tw-gap-[20px]">
          <!-- Field : Role title -->
          <BaseInput
            v-model="formModel.roleTitle"
            :validation="vueValidate.roleTitle"
            :validate-on-blur="true"
            data-cy-id="add-role-modal-role-title"
            :placeholder="
              getComponentUiText(
                'app-settings-team-roles-add-role-modal-form-prompt-role-title-1',
              )
            "
            :label="
              getComponentUiText(
                'app-settings-team-roles-add-role-modal-form-label-role-title-1',
              )
            "
            @update:value="handleInputRoleTitle"
          />
          <!-- Field : Privilege level -->
          <b-row
            class="sm-display-column-container tw-flex tw-justify-between tw-items-center"
          >
            <b-col
              sm="5"
              class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
            >
              {{
                getUiText(
                  "app-settings-team-roles-add-role-modal-form-label-privilege-level-1",
                )
              }}
              <span class="tw-text-[#F7553C]">*</span>
            </b-col>
            <b-col sm="7" class="field-content-container tw-flex">
              <div class="dropdown-container tw-flex-1 dropdown">
                <CustomBDropDown
                  :id="'dropdownIcon'"
                  :type="'single'"
                  :data="formModel.privilegeLevel"
                  :validation="vueValidate?.privilegeLevel"
                  data-cy-id="add-role-modal-privilege-level"
                  :class-name="'gray-dropdown-container tw-h-[58px]'"
                  :placeholder="
                    getUiText(
                      'app-settings-team-roles-add-role-modal-form-prompt-privilege-level-1',
                    )
                  "
                  @update:move-selection-down="moveSelectionDown"
                  @update:show-drop="handleDrop"
                  @update:enter-value="handlEnter"
                  @update:move-selection-up="moveSelectionUp"
                >
                  <CustomBDropDownItem
                    v-for="(level, index) in privilegeLevelOptions"
                    :key="index"
                    :data-cy-id="`add-role-modal-privilege-level-${index}`"
                    :data="level"
                    :class-name="`normal-dropdown-container ${
                      activeItem === index ? 'activeItem' : ''
                    }`"
                    @click="handleSelectPrivilegeLevel(level)"
                  />
                </CustomBDropDown>
              </div>
            </b-col>
          </b-row>
          <!-- divider -->
          <div
            v-if="noOfAnotherOrgs > 0"
            class="tw-px-[0px] tw-py-[15px] tw-w-full tw-flex tw-items-center"
          >
            <div class="tw-w-full tw-h-[1px] tw-bg-[#EFF0F1]" />
          </div>
          <span
            v-if="noOfAnotherOrgs > 0"
            class="tw-text-[#211F58] tw-text-[18px] tw-not-italic tw-font-[600] tw-leading-[130%]"
            >{{
              getComponentUiText(
                "app-component-add-role-modal-add-users-role-1",
              )
            }}</span
          >
          <!-- Field : Organisation -->
          <b-row
            class="sm-display-column-container tw-flex tw-justify-between tw-items-center"
          >
            <b-col
              sm="5"
              class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
            >
              {{
                getUiText(
                  "app-component-custom-b-dropdown-label-organisation-1",
                )
              }}
              <span class="tw-text-[#F7553C]">*</span>
            </b-col>
            <b-col sm="7" class="field-content-container tw-flex">
              <div class="dropdown-container tw-flex-1 dropdown">
                <CustomBDropDown
                  :id="'dropdownIcon'"
                  :type="'single'"
                  :data="formModel.organisation"
                  :validation="vueValidate?.organisation"
                  :class-name="'gray-dropdown-container tw-h-[58px]'"
                  :placeholder="
                    getUiText(
                      'app-component-custom-b-dropdown-prompt-organisation-1',
                    )
                  "
                  @update:move-selection-down="moveSelectionDown"
                  @update:show-drop="handleDrop"
                  @update:enter-value="handlEnter"
                  @update:move-selection-up="moveSelectionUp"
                >
                  <CustomBDropDownItem
                    v-for="(company, index) in organisationOptions"
                    :key="index"
                    :data="company"
                    :class-name="`normal-dropdown-container ${
                      activeItem === index ? 'activeItem' : ''
                    }`"
                    @click="handleSelectOrganisation(company)"
                  />
                </CustomBDropDown>
              </div>
            </b-col>
          </b-row>
          <!-- Field : Users -->
          <b-row
            class="sm-display-column-container tw-flex tw-justify-between tw-items-center"
          >
            <b-col
              sm="5"
              class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
            >
              {{
                getUiText("app-component-custom-b-dropdown-label-select-user-1")
              }}
              <span class="tw-text-[#F7553C]">*</span>
            </b-col>
            <b-col sm="7" class="field-content-container tw-flex">
              <div class="dropdown-container tw-flex-1 dropdown">
                <CustomMultiSelectSearch
                  v-model="formModel.users"
                  :options="userSelects"
                  track-by="name"
                  data-cy-id="add-role-modal-select-user"
                  label="name"
                  :placeholder="`${getUiText(
                    'app-settings-team-roles-add-role-modal-form-prompt-select-users-1',
                  )}`"
                  :show-check-box="true"
                  :validation="vueValidate?.users"
                  @update:model-value="handleInputUser($event)"
                  @close:modal="handleInputUser($event)"
                />
              </div>
            </b-col>
          </b-row>
          <div
            v-for="(i, indx) of [...Array(noOfAnotherOrgs).keys()]"
            :key="indx"
            class="tw-flex tw-flex-col tw-gap-[20px]"
          >
            <div
              class="tw-px-[0px] tw-py-[15px] tw-w-full tw-flex tw-items-center"
            >
              <div class="tw-w-full tw-h-[1px] tw-bg-[#EFF0F1]" />
            </div>
            <!-- Field : Another Organisation -->
            <b-row
              class="sm-display-column-container tw-flex tw-justify-between tw-items-center"
            >
              <b-col
                sm="5"
                class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
              >
                {{
                  getUiText(
                    "app-component-custom-b-dropdown-label-another-organisation-1",
                  )
                }}
                <span class="tw-text-[#F7553C]">*</span>
              </b-col>
              <b-col sm="7" class="field-content-container tw-flex">
                <div class="dropdown-container tw-flex-1 dropdown">
                  <CustomBDropDown
                    :id="'dropdownIcon'"
                    :type="'single'"
                    :data="[formModel.anotherOrganisation[indx]]"
                    :validation="vueValidate?.anotherOrganisation"
                    :class-name="'gray-dropdown-container tw-h-[58px]'"
                    :placeholder="
                      getUiText(
                        'app-component-custom-b-dropdown-prompt-organisation-1',
                      )
                    "
                    @update:move-selection-down="moveSelectionDown"
                    @update:show-drop="handleDrop"
                    @update:enter-value="handlEnter"
                    @update:move-selection-up="moveSelectionUp"
                  >
                    <CustomBDropDownItem
                      v-for="(company, index) in [
                        formModel.anotherOrganisation[indx],
                        ...remainingAccessableOrgs,
                      ].filter((item) => item)"
                      :key="index"
                      :data="company"
                      :class-name="`normal-dropdown-container ${
                        activeItem === index ? 'activeItem' : ''
                      }`"
                      @click="handleSelectAnotherOrganisation(company, indx)"
                    />
                  </CustomBDropDown>
                </div>
              </b-col>
            </b-row>
            <!-- Field :Another Users -->
            <b-row
              class="sm-display-column-container tw-flex tw-justify-between tw-items-center"
            >
              <b-col
                sm="5"
                class="field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium"
              >
                {{
                  getUiText(
                    "app-component-custom-b-dropdown-label-select-user-1",
                  )
                }}
                <span class="tw-text-[#F7553C]">*</span>
              </b-col>
              <b-col sm="7" class="field-content-container tw-flex">
                <div class="dropdown-container tw-flex-1 dropdown">
                  <CustomMultiSelectSearch
                    v-model="formModel.anotherOrgUsers[indx]"
                    :options="anotherOrgUsers[indx]"
                    track-by="name"
                    label="name"
                    :placeholder="`${getUiText(
                      'app-settings-team-roles-add-role-modal-form-prompt-select-users-1',
                    )}`"
                    :show-check-box="true"
                    :validation="vueValidate?.users"
                    @update:model-value="handleInputUser($event)"
                    @close:modal="handleInputUser($event)"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div
          class="button-container tw-flex tw-flex-col tw-items-end tw-mt-[20px]"
        >
          <div
            :class="`tw-flex tw-mb-[40px] tw-gap-[10px] tw-cursor-pointer ${
              addAnotherOrgUserDisable ? 'tw-pointer-events-none' : ''
            }`"
            @click="
              () => {
                noOfAnotherOrgs = noOfAnotherOrgs + 1;
                if (organisationOptions.length - noOfAnotherOrgs <= 1) {
                  addAnotherOrgUserDisable = true;
                }
              }
            "
          >
            <span
              :class="`tw-text-[13px] ${
                addAnotherOrgUserDisable
                  ? 'tw-text-[#B7B7B7]'
                  : 'tw-text-[#231F20]'
              } tw-font-medium tw-leading-[28px]`"
              >{{
                getUiText(
                  "app-settings-team-roles-add-role-modal-form-button-add-user-description-1",
                )
              }}</span
            >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="28"
                height="28"
                rx="14"
                :fill="addAnotherOrgUserDisable ? '#DBDBDB' : '#387DFF'"
              />
              <path
                d="M18.0811 14.992H14.8491V18.304H13.1531V14.992H9.92106V13.456H13.1531V10.144H14.8491V13.456H18.0811V14.992Z"
                fill="white"
              />
            </svg>
          </div>
          <b-button
            data-cy="add-role-modal-submit-button"
            type="submit"
            variant="primary"
            class="button-verify tw-bg-[#387DFF] tw-h-[39px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
          >
            <LottieAnimation
              v-if="showLoadingSubmitButton"
              :class="'tw-h-[41px] tw-w-full'"
              :animation-data="getProgressAnimation()"
              :auto-play="true"
              :loop="true"
            />

            <span>
              {{
                getUiText(
                  "app-settings-team-roles-add-role-modal-form-button-create-role-1",
                )
              }}
            </span>
          </b-button>
        </div>
      </div>
    </BaseForm>
  </Modal>
</template>

<script setup lang="ts">
import store from "../../../store";
import utilities, {
  getComponentUiText,
  getProgressAnimation,
} from "../../../utils/utilities";
import { Ref, computed, reactive, ref, watch } from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import CustomBDropDown from "../../common/customBDropDown.vue";
import CustomBDropDownItem from "../../common/customBDropDownItem.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import CustomMultiSelectSearch from "@/components/common/customMultiSelectSearch.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  getOrgRoletypes,
  postOrgRole,
  getOrgMembersAddable,
  getOrgAccessGranted,
} from "@/services/org";
import get from "lodash/get";
import { IOrgDetails } from "@/interfaces/orgInterfaces";
import { IOrgRoleInput } from "@/interfaces/org/role";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseForm from "@/components/common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { LottieAnimation } from "lottie-web-vue";

const activeItem = ref(0);
const DEFAULT_MAX_WIDTH_MODAL = 65;
const remainingAccessableOrgs = ref([]);
const noOfAnotherOrgs = ref(0);
const anotherOrgUsers = ref([]);
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
});
// Form modal and validation.
let formModel = reactive({
  roleTitle: "",
  privilegeLevel: [] as IDropDownData[],
  organisation: [] as IDropDownData[],
  users: [] as IDropDownData[],
  anotherOrganisation: [] as IDropDownData[],
  anotherOrgUsers: [],
});

const rules = {
  roleTitle: {
    required,
  },
  privilegeLevel: {
    required,
  },
  organisation: {
    required,
  },
  users: {
    required: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-team-roles-add-role-modal-form-error-required-users-1",
        ),
      required,
    ),
  },
  anotherOrganisation: {
    required: noOfAnotherOrgs.value > 0 ? true : false,
  },
  anotherOrgUsers: {
    required:
      noOfAnotherOrgs.value > 0
        ? helpers.withMessage(
            () =>
              getComponentUiText(
                "app-settings-team-roles-add-role-modal-form-error-required-users-1",
              ),
            required,
          )
        : false,
  },
};
const currentOrg: Ref<IOrgDetails> = computed(
  () => store.getters["Org/getOrgDetails"],
);
const userSelectsCurrentOrg: Ref<any> = computed(
  () => store.getters["Org/getAddableOrgs"],
);
const userSelects: Ref<IDropDownData[]> = ref([]);
const organisationOptions: Ref<IDropDownData[]> = ref([]);
const privilegeLevelOptions: Ref<IDropDownData[]> = ref([]);
const emit = defineEmits(["update:show", "add:organisation"]);
const CUSTOM_CLASS_INPUT_INVALID = "input-invalid-style-1";
const formModalOrigin = Object.assign({}, formModel);
const addAnotherOrgUserDisable = ref(organisationOptions.value.length <= 1);
const showLoadingSubmitButton: Ref<boolean> = ref(false);

const cssFieldTitle =
  "tw-border tw-text-[#231F20] tw-text-[13px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#EFF0F180] tw-max-w-[520px]";

let vueValidate;
let showRef = ref(props.show);
let needCheckValidSelectUsers = ref(false);
let customClassInputInvalidRoleTitle = ref(cssFieldTitle);
watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) {
      initial();
      vueValidate = useVuelidate(rules, formModel);
      if (organisationOptions.value.length) onSelectOrgDefault();
    }
  },
);

watch(
  () => formModel.organisation,
  () => {
    formModel.anotherOrganisation = [];
    anotherOrgUsers.value = [];
  },
);
watch(
  [() => formModel.organisation, () => formModel.anotherOrganisation],
  () => {
    const ids = [
      ...Object.values(formModel.anotherOrganisation).map(
        (org: any) => org?.id,
      ),
      formModel.organisation[0]?.id,
    ];
    remainingAccessableOrgs.value = organisationOptions.value.filter(
      (org) => !ids.includes(org?.id),
    ) as any;
  },
  { deep: true, immediate: true },
);

watch(
  () => organisationOptions.value,
  (value) => {
    addAnotherOrgUserDisable.value = value?.length <= 1;
    noOfAnotherOrgs.value = 0;
    formModel.anotherOrganisation = [];
    formModel.anotherOrgUsers = [];
  },
  { immediate: true },
);

const onSelectOrgDefault = () => {
  const indexOrg = organisationOptions.value.findIndex((org) => {
    return org.id === currentOrg.value.id;
  });
  const indexSelectedOrg = indexOrg > -1 ? indexOrg : 0;
  formModel.organisation = [organisationOptions.value[indexSelectedOrg]];
  userSelects.value = userSelectsCurrentOrg.value;
  userSelects.value.forEach((e, index) => {
    e._index = index;
  });
};

const initial = async () => {
  if (organisationOptions.value.length) await onSelectOrgDefault();

  getPrivilegeLevelOptions();
  await getDataOption();

  showRef.value = props.show;
  vueValidate = useVuelidate(rules, formModel);
};

const getDataOption = async () => {
  await getOrganizationOptions();
};

const getPrivilegeLevelOptions = async () => {
  try {
    const responseData = await getOrgRoletypes();
    const privilegeLevelOptionsResponse = get(responseData, "data.data", []);
    privilegeLevelOptions.value = privilegeLevelOptionsResponse.map((item) => {
      return {
        id: item.roleTypeId,
        name: item.roleTypeName,
      };
    });
  } catch (error: any) {
    privilegeLevelOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgRoleTypes);
    }
  }
};

const getOrganizationOptions = async () => {
  try {
    const responseData = await getOrgAccessGranted();
    const organizationOptionsResponse = get(
      responseData,
      "data.data.grantedOrgs",
      [],
    );
    organizationOptionsResponse.push({
      org2Id: currentOrg.value.id,
      org2NameShort: currentOrg.value.nameShort,
    });
    organisationOptions.value = organizationOptionsResponse.map((item) => {
      return {
        id: item.org2Id, // TO-DO: Change to orgId
        name: item.org2NameShort,
      };
    });
    onSelectOrgDefault();
  } catch (error: any) {
    organisationOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getAccessGrantedToOtherOrgs);
    }
  }
};

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleInputRoleTitle = () => {
  vueValidate.value.roleTitle.$touch();
  vueValidate.value.roleTitle.$model = formModel.roleTitle;

  if (vueValidate.value.roleTitle.$errors.length) {
    customClassInputInvalidRoleTitle.value = `${customClassInputInvalidRoleTitle.value} ${CUSTOM_CLASS_INPUT_INVALID}`;
  } else customClassInputInvalidRoleTitle.value = cssFieldTitle;
};

const handleInputUser = (value) => {
  if (needCheckValidSelectUsers.value === false) return;

  formModel.users = value;
  vueValidate.value.users.$touch();
  vueValidate.value.users.$model = formModel.users;
};

const handleSelectOrganisation = (item: IDropDownData) => {
  formModel.organisation = [item];
  vueValidate.value.organisation.$touch();
  vueValidate.value.organisation.$model = formModel.organisation;
  getUserOfOrg(item.id);
};

const handleSelectAnotherOrganisation = (item: any, index: number) => {
  formModel.anotherOrganisation[index] = item;
  vueValidate.value.anotherOrganisation.$touch();
  vueValidate.value.anotherOrganisation.$model = formModel.anotherOrganisation;
  getUserOfOrg(item.id, index, true);
};

const getUserOfOrg = async (
  orgId: any,
  index: any = -1,
  isAnotherOrgUsers = false,
) => {
  try {
    const responseData = await getOrgMembersAddable(orgId);
    if (responseData.data?.data?.length) {
      if (isAnotherOrgUsers) {
        if (index === -1) return;
        const temp: any = [...anotherOrgUsers.value];
        temp[index] = responseData.data.data.map((org: any) => {
          return {
            ...org,
            id: org.userId,
            name: `${org.firstName} ${org.lastName}`,
          };
        });
        anotherOrgUsers.value = temp;
      } else {
        userSelects.value = responseData.data.data.map((org: any) => {
          return {
            ...org,
            id: org.userId,
            name: `${org.firstName} ${org.lastName}`,
          };
        });
      }
    }
  } catch (error: any) {
    organisationOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getAddableOrgMembers);
    }
  }
};

const handleSelectPrivilegeLevel = (item: IDropDownData) => {
  formModel.privilegeLevel = [item];
  vueValidate.value.privilegeLevel.$touch();
  vueValidate.value.privilegeLevel.$model = formModel.privilegeLevel;
};
const handleDrop = () => {
  activeItem.value = 0;
};
const moveSelectionDown = (step) => {
  if (privilegeLevelOptions.value.length - 1 == activeItem.value) {
    activeItem.value = privilegeLevelOptions.value.length - 1;
  } else if (activeItem.value < privilegeLevelOptions.value.length) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop += 61;
    }
  }
};
const moveSelectionUp = (step) => {
  if (activeItem.value >= 1) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop -= 61;
    }
  }
};
const handlEnter = () => {
  const handleData = privilegeLevelOptions.value[activeItem.value];
  handleSelectPrivilegeLevel(handleData);
};
const onSubmit = async () => {
  try {
    showLoadingSubmitButton.value = true;
    needCheckValidSelectUsers.value = true;

    const result = await vueValidate.value.$validate();
    if (result) {
      const payload: IOrgRoleInput = {
        roleName: formModel.roleTitle,
        roleDescription: "",
        roleTypeId: formModel.privilegeLevel[0].id as string,
        roleMembers: formModel.users.map((item) => item.id) as any,
      };
      const res = await postOrgRole(payload);
      await store.dispatch("Org/fetchOrgRoles");
      const roleTitle = formModel.roleTitle;
      EventEmitter.emit(EmitterEvents.ROLE_CREATED, {
        roleTitle,
        member: res.data?.data || {},
      });
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.postOrgRole);
    }
  } finally {
    showLoadingSubmitButton.value = false;
  }
};

const clearData = () => {
  formModel = reactive(Object.assign({}, formModalOrigin));
  userSelects.value.forEach((item) => (item.selected = false));
  customClassInputInvalidRoleTitle.value = cssFieldTitle;
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  needCheckValidSelectUsers.value = false;
  emit("update:show", showRef.value);
};
</script>

<style lang="scss">
.activeItem {
  background-color: #eff0f1 !important;
  border: 1px solid #eff0f1;
}
.role-details-modal {
  .button-verify.btn.btn-primary[disabled] {
    background-color: #dbdbdb;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .copy-info-container {
    max-width: 70%;
  }

  .text-copy-container {
    width: calc(100% - 22px);
  }

  .button-delete {
    line-height: 100%;
    background-color: #f7553c;
    border-color: #f7553c;
  }

  .button-verify-later {
    line-height: 100%;
    border: 2px solid #387dff;
    background-color: #ffffff;
    color: #387dff;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }

  .status-domain {
    padding: 3px 5px;
    font-family: Poppins;
    font-size: 11px;
    font-weight: 500;
    line-height: 130%;
    border-radius: 4px;

    background: var(--ui-green-soft, #d9ede2);
    color: #01893d;
  }
}

.btn-secondary {
  width: 100%;
  text-align: left;
  line-height: 100%;
  padding: 11px 20px;
  color: #231f20;
  font-size: 13px;
  background: transparent;
  border: none;
  box-shadow: none;

  .placeholder {
    color: #b7b7b7;
    background-color: transparent !important;
    opacity: 1;
  }
  &:hover,
  &:focus &:active,
  &:active:focus {
    color: #b7b7b7;
    font-size: 13px;
    background: transparent;
    border: none;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  }

  &::after {
    display: none;
  }
}

// style tab
.gray-dropdown-container {
  width: 100%;

  .btn-secondary {
    width: 100%;
    text-align: left;
    line-height: 100%;
    padding: 11px 20px;

    color: #b7b7b7;
    font-size: 13px;

    background-color: #eff0f180;
    border: 1px solid #eff0f1;
    box-shadow: none;
    &:hover,
    &:focus,
    &:active,
    &:active:focus {
      color: #b7b7b7;
      font-size: 13px;
      background-color: #eff0f180;
      border: 1px solid #eff0f1;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
    }
  }

  .dropdown-toggle::after {
    display: none;
  }
  &.tw-text-normal {
    .btn {
      color: #231f20;
    }
  }
}
@media (min-height: 768px) {
  .role-details-modal {
    .modal-main {
      overflow: visible;

      .dropdown-menu {
        max-height: 169px;
        overflow: auto;
      }
    }
  }
}

@media (max-width: 991px) {
  .copy-info-container {
    max-width: fit-content;
  }
}

@media (max-width: 576px) {
  .role-details-modal {
    .sm-display-column-container {
      align-items: flex-start;
      flex-direction: column;

      .field-title-container {
        line-height: 24px;
        height: 24px;
      }

      .field-content-container {
        max-width: 100%;
      }
    }
  }
}

@media (max-width: 420px) {
  .button-container-left {
    margin-top: 10px;
  }

  .sm-display-column-container {
    align-items: flex-start;
    flex-direction: column;

    .field-title-container {
      line-height: 24px;
      height: 24px;
    }

    .field-content-container {
      max-width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .modal-manage-role {
    padding: 10px;
  }

  .field-content-container {
    display: grid;
    grid-template-columns: auto 48px;
    grid-template-areas:
      "input text"
      "dropdown dropdown";

    .input-container {
      grid-area: input;
    }

    .text-container {
      grid-area: text;
    }
  }
}
</style>
